import { render, staticRenderFns } from "./engineeringManagement.vue?vue&type=template&id=63fbc2bd&scoped=true"
import script from "./engineeringManagement.vue?vue&type=script&lang=js"
export * from "./engineeringManagement.vue?vue&type=script&lang=js"
import style0 from "./engineeringManagement.vue?vue&type=style&index=0&id=63fbc2bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbc2bd",
  null
  
)

export default component.exports